import {takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';
import {TYPES as FORUM_COMMENTS_TYPE} from '../creators/forums.comments';


export function fetchSuccess(action) {
    try {
        const { hash } = window.location;
        if (hash !== '') {
            const id = hash.replace('#', '');
            if (document.getElementById(id)) {
                const element = document.getElementById(id);
                if (element) element.scrollIntoView();
            }
        }
    } catch (error) {

    }
}



export function* watchTopicComments() {
    yield takeEvery(FORUM_COMMENTS_TYPE.GET_SUCCESS, fetchSuccess);
}

export default watchTopicComments;

